//********ssl redirect********//
// if(window.location.protocol !== 'https:' && window.location.href.indexOf('10.3.67.47')<0){window.location.replace('https:'+window.location.href.substring(window.location.protocol.length));}
//*****ssl redirect*******//
import '@babel/polyfill'
import 'core-js/stable'
import 'intersection-observer'
import Vue from 'vue'

// vue-breakpoint-component套件要import的部分(保留)
// import { Plugin as VBreakpoint } from 'vue-breakpoint-component'
// Vue.use(VBreakpoint)

import App from './App.vue'
import router from './router'
import store from './store'

//vue google analytics plugin
//npm install vue-analytics
// import VueAnalytics from 'vue-analytics'
// //and then use it in main.js
// Vue.use(VueAnalytics, {
//     id: 'G-1LE0T18Y91',
//     router
// })

//vue google analytics gtag plugin
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-1LE0T18Y91" }
});


import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default options with global component } */)

import vueHeadful from 'vue-headful'
Vue.component('vue-headful', vueHeadful)

//vue meta
import VueMeta from 'vue-meta'
// options 可以作額外設定
Vue.use(VueMeta,
  {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})


import animated from 'animate.css' // npm install animate.css --save安裝後引入
Vue.use(animated)

import WOW from 'wow.js'
  new WOW({ 
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
    live: true
}).init()

//picturefill崁入
import picture from '../src/js/picturefill.js'
Vue.use(picture)

//vue-scrollto npm install --save vue-scrollto
//  var Vue = require('vue');
var VueScrollTo = require('vue-scrollto');
// Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

// import Vuex from 'vuex'
// Vue.use(Vuex)


Vue.config.productionTip = false
Vue.use(BootstrapVue)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// export default new Vuex.Store({
  
//   state: {
//     windowWidth: window.innerWidth,
//   },
//   mutations: {
//     setWindowWidth(state) {
//       state.windowWidth = window.innerWidth;
//     }
//   },
// })



//********jquery plugin********//
var $ = require( "jquery" );
//*****dropdownlist hover*******//
const $dropdown = $(".dropdown");
const $dropdownToggle = $(".dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";
 
$(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 992px)").matches) {
        $dropdown.hover(
        function() {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.find($dropdownMenu).removeClass(showClass);
        }
        );
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
});
